const nation_codes = [
    {'text': '선택안함', 'text_en': 'No Select', 'value': null},
    // 미국·캐나다는 같은 국가 번호라 한 항목이다(값이 같으면 캐나다를 골라도 미국으로 표시된다)
    {'text': '미국·캐나다 (+1)', 'text_en': 'USA / Canada (+1)', 'value': '+1'},
    {'text': '남아프리카공화국 (+27)', 'text_en': 'Republic of South Africa (+27)', 'value': '+27'},
    {'text': '프랑스 (+33)', 'text_en': 'France (+33)', 'value': '+33'},
    {'text': '스페인 (+34)', 'text_en': 'Spain (+34)', 'value': '+34'},
    {'text': '헝가리 (+36)', 'text_en': 'Hungary (+36)', 'value': '+36'},
    {'text': '이탈리아 (+39)', 'text_en': 'Italy (+39)', 'value': '+39'},
    {'text': '루마니아 (+40)', 'text_en': 'Romania (+40)', 'value': '+40'},
    {'text': '스웨덴 (+46)', 'text_en': 'Sweden (+46)', 'value': '+46'},
    {'text': '폴란드 (+48)', 'text_en': 'Poland (+48)', 'value': '+48'},
    {'text': '독일 (+49)', 'text_en': 'Germany (+49)', 'value': '+49'},
    {'text': '멕시코 (+52)', 'text_en': 'Mexico (+52)', 'value': '+52'},
    {'text': '브라질 (+55)', 'text_en': 'Brazil (+55)', 'value': '+55'},
    {'text': '인도네시아 (+62)', 'text_en': 'Indonesia (+62)', 'value': '+62'},
    {'text': '일본 (+81)', 'text_en': 'Japan (+81)', 'value': '+81'},
    {'text': '한국 (+82)', 'text_en': 'Korea (+82)', 'value': '+82'},
    {'text': '베트남 (+84)', 'text_en': 'Vietnam (+84)', 'value': '+84'},
    {'text': '중국 (+86)', 'text_en': 'China (+86)', 'value': '+86'},
    {'text': '터키 (+90)', 'text_en': 'Turkey (+90)', 'value': '+90'},
    {'text': '인도 (+91)', 'text_en': 'India (+91)', 'value': '+91'},
    {'text': '룩셈부르크 (+352)', 'text_en': 'Luxembourg (+352)', 'value': '+352'},
    {'text': '체코 (+420)', 'text_en': 'Czech (+420)', 'value': '+420'},
    {'text': '슬로바키아 (+421)', 'text_en': 'Slovakia (+421)', 'value': '+421'}
];

const role_mapping = {
    1: '기업 일반 참여자',
    2: '기업 평가 관리자',
};

const access_status_mapping = {
    0: '접근 가능',
    1: '접근 요청',
    2: '접근 거부'
};



export {nation_codes, role_mapping, access_status_mapping};
